import {PRODUCTION} from './production'
import {TESTING} from './testing'

export const YANDEX = {production: PRODUCTION, testing: TESTING}
